module.exports = __webpack_public_path__ + "static/media/surgeryImage.0257fa9a.jpg";